<template>
  <div class="mainContent grid">
    <div class="page-block u-16">
      <div class="grid u-16 between">
        <div class="title-page">
          <h1>Терминалы</h1>
        </div>
        <!-- <div v-if="getProfile.is_admin">
            <button class="button button__add">
              <span>Добавить терминал</span>
            </button>
        </div>-->
      </div>
      <el-table
        :data="terminalList"
        class="terminals-page"
        size="medium"
        :default-sort="{ prop: 'name', order: 'ascending' }"
        v-loading="terminalList.length == 0"
        :height="tHeight"
      >
        <el-table-column prop="id" label="Id" width="60" sortable></el-table-column>
        <el-table-column prop="name" label="Название" width="250" sortable></el-table-column>
        <el-table-column label="Дата создания" prop="date_created" sortable width="180">
          <template slot-scope="scope">
            <span>{{ scope.row.date_created | momentFormat() }}</span>
          </template>
        </el-table-column>
        <el-table-column label="Дата обновления" prop="date_updated" sortable width="180">
          <template slot-scope="scope">
            <span>{{ scope.row.date_updated | momentFormat() }}</span>
          </template>
        </el-table-column>
        <el-table-column label="Предприятие" prop="merchant_id" min-width="200">
          <template slot-scope="scope">
            {{
            merchantName(scope.row.merchant_id)
            }}
          </template>
        </el-table-column>
        <el-table-column label="Процессинг" prop="processing_id" min-width="180">
          <template slot-scope="scope">
            <img :src="processingIcon(scope.row.processing_id)" class="processing-icon" />
            {{ processingName(scope.row.processing_id) }}
          </template>
        </el-table-column>
        <el-table-column label="Валюта" align="center" prop="currency_code" min-width="120">
          <template slot-scope="scope">
            {{
            currencyCharacter(scope.row.currency_code)
            }}
          </template>
        </el-table-column>
        <el-table-column label="Антифрод" align="center" prop="is_antifraud" min-width="120">
          <template slot-scope="scope">
            <span v-if="scope.row.is_antifraud">
              <i class="el-icon-check"></i>
            </span>
            <span v-if="!scope.row.is_antifraud">
              <i class="el-icon-minus"></i>
            </span>
          </template>
        </el-table-column>
        <el-table-column
          label="Apple Pay"
          align="center"
          prop="is_apple_pay"
          min-width="120"
          sortable
        >
          <template slot-scope="scope">
            <span v-if="scope.row.is_apple_pay">
              <i class="el-icon-check"></i>
            </span>
            <span v-if="!scope.row.is_apple_pay">
              <i class="el-icon-minus"></i>
            </span>
          </template>
        </el-table-column>
        <el-table-column label="Выплаты" align="center" prop="is_payout" min-width="120" sortable>
          <template slot-scope="scope">
            <span v-if="scope.row.is_payout">
              <i class="el-icon-check"></i>
            </span>
            <span v-if="!scope.row.is_payout">
              <i class="el-icon-minus"></i>
            </span>
          </template>
        </el-table-column>
        <el-table-column label v-if="hasGenerateCSRRight || isAdmin">
          <template slot-scope="scope">
            <el-button
              type="text"
              icon="el-icon-setting"
              size="medium"
              @click="openDialog(scope.row)"
            ></el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-dialog
        title="Настройка Apple Pay"
        :visible.sync="dialogVisible"
        width="30%"
        class="terminals-dialog"
      >
        <div class="grid">
          <div class="u-16">
            <div v-if="terminal.name">
              Терминал:
              <strong>{{ terminal.name }}</strong>
            </div>
            <hr class="u-16 ver-margin-10" />
            <div class="u-16 grid" v-if="!generateSuccess">
              <p class="u-16 description">
                Скачайте файл запроса подписи сертификата (CSR). Используя
                полученный CSR, создайте Payment Processing Certificate в
                парнерском центре Apple.
              </p>
              <br />

              <el-button
                icon="el-icon-download"
                type="primary"
                @click="downloadCSR"
                :loading="buttonLoading"
                :disabled="buttonLoading"
                class="ver-margin-20"
              >Скачать CSR</el-button>
              <el-alert
                type="warning"
                :closable="false"
                description="Обратите внимание: при каждом нажатии на кнопку «Скачать CSR»
                выдается новый, уникальный запрос на подпись сертификата."
              ></el-alert>
              <hr class="u-16 ver-margin-15" />
              <p class="description">Загрузите созданный сертификат.</p>
              <el-upload
                class="u-16"
                drag
                :action="uploadAction"
                :headers="uploadHeaders"
                :file-list="fileList"
                :on-error="uploadError"
                :on-success="uploadSuccess"
                :limit="filelimit"
                :accept="fileAccept"
                name="cer"
              >
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">
                  Перетащите файл сюда или
                  <em>кликните для загрузки</em>
                </div>
              </el-upload>
            </div>
            <div class="grid" v-if="generateSuccess">
              <el-alert
                type="success"
                class="u-16"
                :closable="false"
                description="Apple Pay настроен успешно"
              ></el-alert>
            </div>
          </div>
        </div>

        <span slot="footer" class="dialog-footer">
          <el-button v-if="!generateSuccess" @click="dialogVisible = false">Отмена</el-button>
          <el-button v-if="generateSuccess" type="primary" @click="dialogVisible = false">Закрыть</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import Vuex from "vuex";
import { mapGetters } from "vuex";
import store from "../store";

import { _ } from "underscore";
import axios from "axios";
import { apiUrl } from "@/api/apiUrl";
import editTerminal from "@/components/terminalActions/editTerminal";
export default {
  name: "Terminals",
  data() {
    return {
      tHeight: 0,
      filelimit: 1,
      fileList: [],
      terminal: {},
      fileAccept: ".cer",
      generateSuccess: false,
      dialogVisible: false,
      buttonLoading: false,
    };
  },
  methods: {
    tableHeight() {
      this.tHeight = document.documentElement.clientHeight - 165;
    },
    openDialog(row) {
      this.dialogVisible = true;
      this.fileList = [];
      this.terminal = row;
      this.generateSuccess = false;
    },
    downloadCSR() {
      const id = this.terminal.id;
      this.buttonLoading = true;
      axios
        .post(
          apiUrl + "terminal/applepay/generate-csr",
          { terminal_id: id },
          {
            headers: {
              "Authorization-Token": localStorage.getItem(
                "Authorization-Token"
              ),
            },
          }
        )
        .then(({ data }) => {
          const url = data.url;
          if (url) {
            fetch(url, {
              method: "GET",
              headers: { "Content-Type": "text/csv" },
            })
              .then(function (res) {
                return res.blob();
              })
              .then((myBlob) => {
                let url = window.URL.createObjectURL(myBlob);
                let link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", this.terminal.name + ".csr");
                document.body.appendChild(link);
                link.click();
              })
              .catch((err) => {
                throw err;
              });
          }
          this.buttonLoading = false;
        })
        .catch((err) => {
          this.showErrorMessage(
            "(" + err.response.status + ") " + err.response.data.message
          );
        });
    },
    uploadError(err, file, fileList) {
      this.showErrorMessage(
        "(" + err.status + ") " + JSON.parse(err.message).message
      );
    },
    uploadSuccess() {
      this.generateSuccess = true;
    },
    showErrorMessage(message) {
      this.$message({
        type: "error",
        message,
      });
    },
  },
  computed: {
    ...mapGetters([
      "getProfile",
      "getRights",
      "merchantList",
      "merchantName",
      "terminalList",
      "terminalName",
      "processingList",
      "processingName",
      "processingIcon",
      "currencyCharacter",
      "isSidebarOpened",
    ]),
    uploadAction() {
      return apiUrl + "terminal/applepay/generate-key/" + this.terminal.id;
    },
    uploadHeaders() {
      return {
        "Authorization-Token": localStorage.getItem("Authorization-Token"),
      };
    },
    isAdmin() {
      return this.getProfile.is_admin || false;
    },
    hasGenerateCSRRight() {
      return this.getRights.indexOf("generate_csr") != -1;
    },
  },
  beforeMount() {
    this.$store.dispatch("getMerchant");
    this.$store.dispatch("getTerminal");
    this.$store.dispatch("getProcessing");
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener("resize", this.tableHeight);
      this.tableHeight();
    });
    if (this.isSidebarOpened) {
      setTimeout(() => {
        store.commit("hideSidebar");
      }, 500);
    }
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.tableHeight);
  },
  components: {
    editTerminal,
  },
};
</script>

<style lang="sass">
@import '../assets/style/terminals'
</style>
